import ConnectedLogin, { Login } from './Login';

export { Login };
export default ConnectedLogin;
